<template>
  <div class="cart-detail-box">
    <div class="added-product unab" v-if="unavailable_cart_items.length">
      <h4>{{ _T('Item(s) Unavailable') }}</h4>
      <ul>
        <unavailable-item
          class="removed-item"
          v-for="item in unavailable_cart_items"
          :item="item"
          :key="'removed' + item.index"
        ></unavailable-item>
      </ul>
      <div class="remove-unavailableitems">
        <button class="btn btn-danger" @click="removeUnavailableItems">
          {{ _T('Remove All') }}
        </button>
      </div>
      <hr />
    </div>
    <div class="added-product">
      <ul>
        <Item
          v-for="item in available_cart_items"
          :item="item"
          :key="item.index"
        ></Item>
      </ul>
      <!-- <a href="javascript:void(0)" @click="addmoreitems" class="btn btn-solid btn-add">+ {{_T('add more items')}}</a> -->
      <router-link :to="{ name: 'home' }" class="btn btn-solid btn-add"
        >+ {{ _T('add more items') }}</router-link
      >
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
// import Modifier from './Modifier';

import Item from './Item'
import UnavailableItem from './MobileUnavailableItems'
export default {
  name: 'Items',
  components: { Item, UnavailableItem },
  computed: {
    ...mapGetters(['available_cart_items', '_T', 'unavailable_cart_items']),
    ...mapState({
      selectedItem: state => state.cart_store.selectedItem,
    }),
  },
  methods: {
    removeUnavailableItems() {
      this.$store.dispatch('removeUnavailableItems')
    }
  }
}
</script>

<style lang="scss" scoped>
@media (max-width: 575px) {
  .body-rtl {
    .added-product {
      ul {
        padding-right: 0;
      }
    }
  }
  .removed-item {
    background: #fbd9d9 !important;
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 10px;
  }
}
</style>
